import React from 'react';
import PropTypes from 'prop-types';

import OEColor from '../color-picker/oe-color';
import OEColorHelper from '../../lib/color/oe-color-helper';

export default class OEThemeIndicatorView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            defaultActivityColor: OEColor.toDOMStr(OEColorHelper.themeColor())
        };

        this.onColorModelChanged = this.onColorModelChanged.bind(this);
    }

    componentDidMount()    {
        this.onColorModelChanged();
        OEColorHelper.registerModelChangeListener(this.onColorModelChanged);
    }

    componentWillUnmount()    {
        OEColorHelper.unregisterModelChangeListener(this.onColorModelChanged);
    }

    onColorModelChanged()   {
        this.setState({
            defaultActivityColor: OEColor.toDOMStr(OEColorHelper.themeColor())
        });
    }

    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
      
        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    }

    renderArc(x, y, radius, startAngle, endAngle, stroke, strokeWidth, fill, className, filter) {
        const start = this.polarToCartesian(x, y, radius, endAngle);
        const end = this.polarToCartesian(x, y, radius, startAngle);
        
        const arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
        
        const d = [
            "M", start.x, start.y, 
            "A", radius, radius, 0, arcSweep, 0, end.x, end.y
        ].join(" ");
            
        return <path className={className} d={d} stroke={stroke} strokeWidth={strokeWidth} fill={fill} filter={filter}/>;
    }

    render() {
        const dimension = 100;
        const dimHalf = 0.5*dimension;

        const shadowRadius = 0.5*this.props.shadowRadius * dimension;
        const shadowOffset = {x: this.props.shadowOffset.x * dimension, y: this.props.shadowOffset.y * dimension};

        const shadowInset = 2*shadowRadius;
        const dim = dimension - 2*shadowInset;

        const activityWidth = this.props.activityWidth * dim;
        const progressWidth = this.props.progressWidth * dim;
        
        const activityInset = progressWidth + 0.5 * activityWidth + shadowInset;
        const progressInset = 0.5 * progressWidth + shadowInset;

        const activityColor = this.props.activityColor ? this.props.activityColor : this.state.defaultActivityColor;

        return (

            <div className={"theme-indicator-view " + this.props.className}>

                <svg className="activity-ring" viewBox="0 0 100 100">

                    <defs>
                        <filter id="f3" width="150%" height="150%">
                            <feGaussianBlur in="SourceAlpha" stdDeviation={shadowRadius} edgeMode="none"/>
                            <feOffset dx={shadowOffset.x} dy={shadowOffset.y} result="offsetblur"/>
                            <feComponentTransfer>
                                <feFuncA type="linear" slope={this.props.shadowOpacity}/>
                            </feComponentTransfer>
                            <feMerge>
                                <feMergeNode/>
                                <feMergeNode in="SourceGraphic"/>
                            </feMerge>
                        </filter>
                    </defs>

                    {this.renderArc(50, 50, dimHalf - activityInset, 0, 180, activityColor, activityWidth, 'none', null, 'url(#f3)')}
                </svg>

                <svg className="progress-ring" viewBox="0 0 100 100">
                    {this.renderArc(50, 50, dimHalf - progressInset, 0, Math.min(360*this.props.progress, 359.9999), this.props.progressColor, progressWidth, 'none')}
                </svg>

            </div>
        );
    }
}

OEThemeIndicatorView.defaultProps = {
    className: '',
    animating: true,
    progress: 0.0,
    activityWidth: 0.1,
    progressColor: 'rgba(255,255,255,1)',
    progressWidth: 0.02,
    shadowColor: 'rgba(0,0,0,1)',
    shadowRadius: 0.1,
    shadowOpacity: 0.4,
    shadowOffset: {x: 0.02, y: 0.02}
};

OEThemeIndicatorView.propTypes = {
    className: PropTypes.string,
    animating: PropTypes.bool,
    progress: PropTypes.number,
    activityColor: PropTypes.string,
    activityWidth: PropTypes.number,
    progressColor: PropTypes.string,
    progressWidth: PropTypes.number,
    shadowColor: PropTypes.string,
    shadowRadius: PropTypes.number,
    shadowOpacity: PropTypes.number,
    shadowOffset: PropTypes.object
};